import React from 'react';

function Error() {
  return (
    <div className='error'>
      <h2>Error Component</h2>
      <h6>404 Error Page here</h6>
    </div>
  );
}

export default Error;